import * as Yup from 'yup';
import { Button } from '@chakra-ui/react';
import Dropdown from 'src/components/input/Dropdown';
import Input from 'src/components/input';
import { useNavigate } from 'react-router-dom';
import InputField from 'src/components/input/InputField';
import RightArrow from 'src/assets/icons/RightArrow';
import { useForm } from 'react-hook-form';
// @ts-ignore: TODO upgrade yup to v3
import { yupResolver } from '@hookform/resolvers/yup';
import { useState } from 'react';
import useUpdatePersonalisation from './hooks/useUpdatePersonalisation';

const defaultValues = {
  experienceLevel: '',
  podcastPurpose: '',
  heardAboutFrom: '',
  heardAboutFromDetail: '',
};

const validationSchema = Yup.object().shape({
  experienceLevel: Yup.string().required('Required'),
  podcastPurpose: Yup.string().required('Required'),
  heardAboutFrom: Yup.string().required('Required'),
});

interface PersonaliseFormValues {
  experienceLevel: string;
  podcastPurpose: string;
  heardAboutFrom: string;
  heardAboutFromDetail: string;
}

export default function PersonaliseForm() {
  const navigate = useNavigate();
  const updatePersonalisation = useUpdatePersonalisation();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const onSubmit = (values: PersonaliseFormValues) => {
    setIsSubmitting(true);
    updatePersonalisation(values).then(() => {
      navigate('/success');
    });
  };

  const {
    register,
    handleSubmit,
    formState: { errors },
    watch,
  } = useForm<PersonaliseFormValues>({
    resolver: yupResolver(validationSchema),
    defaultValues,
  });

  const heardAboutFrom = watch('heardAboutFrom');

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Dropdown
        id="experienceLevel"
        my="30px"
        label="How long have you been podcasting?"
        placeholder="Please select"
        invalid={!!errors.experienceLevel}
        errorMessage={String(errors.experienceLevel?.message)}
        selectProps={register('experienceLevel')}
      >
        <option value="new">I&apos;m completely new to podcasting</option>
        <option value="experienced">I&apos;ve already got a podcast</option>
      </Dropdown>
      <Dropdown
        id="podcastPurpose"
        my="30px"
        label="What is your podcast for?"
        placeholder="Please select"
        invalid={!!errors.podcastPurpose}
        errorMessage={String(errors.podcastPurpose?.message)}
        selectProps={register('podcastPurpose')}
      >
        <option value="business">For my business</option>
        <option value="employer">For my employer</option>
        <option value="hobby">For a hobby</option>
        <option value="cause">For a cause</option>
      </Dropdown>
      <Dropdown
        id="heardAboutFrom"
        label="Where did you hear about us?"
        placeholder="Please select"
        invalid={!!errors.heardAboutFrom}
        errorMessage={String(errors.heardAboutFrom?.message)}
        selectProps={register('heardAboutFrom')}
      >
        <option value="searchEngine">Search engine (Google, Bing etc)</option>
        <option value="friendOrColleague">Recommended by a friend or colleague</option>
        <option value="thePodcastHost">ThePodcastHost.com</option>
        <option value="podcast">Heard on a podcast</option>
        <option value="socialMedia">Social media</option>
        <option value="blogOrPublication">Blog or publication</option>
        <option value="podcraft">PodCraft Community</option>
        <option value="other">Other</option>
      </Dropdown>
      {['podcast', 'blogOrPublication', 'other'].includes(heardAboutFrom) && (
        <InputField
          id="heardAboutFromDetail"
          invalid={!!errors.heardAboutFromDetail}
          errorMessage={String(errors.heardAboutFromDetail?.message)}
          mt="18px"
        >
          <Input
            {...register('heardAboutFromDetail')}
            variation="base"
            placeholder={heardAboutFrom === 'other' ? 'Please tell us more' : 'Which one?'}
          />
        </InputField>
      )}
      <Button width="100%" height="54px" type="submit" disabled={isSubmitting} mt="36px" size="lg">
        {isSubmitting ? ' Please wait...' : "Let's start podcasting already!"}
        {!isSubmitting && <RightArrow />}
      </Button>
    </form>
  );
}
